import { useTranslation } from 'react-i18next';
import { Divider, Grid, Typography } from '@frontierag/frontier-ui-library';
import useAccordionVirtualPackProduct from './useVPAccordion';
import useDataFieldHelpers from 'hooks/useDataFieldHelpers';
import type { IVPAccordion } from './types';

export default function VPAccordion({ transNamespace, packProduct, productIndex }: IVPAccordion) {
  const { t } = useTranslation(transNamespace, { keyPrefix: 'OrderSummary' });

  const { renderValue, renderLabel } = useDataFieldHelpers(packProduct);
  const fieldSchema = useAccordionVirtualPackProduct(transNamespace);

  return (
    <>
      <Divider sx={{ mt: 2, mb: -1, ml: { sm: 3, xs: 2 }, width: '97%' }} />
      {fieldSchema.map(({ fields }, index) => (
        <Grid
          direction="row"
          xs={12}
          sm={6}
          container
          item
          spacing={2}
          key={`virtual-pack-column-${index}`}
        >
          {fields.map((field) => (
            <Grid
              item
              xs={12}
              key={`field-${field.accessor}`}
              data-testid={`field-${field.accessor}`}
              sx={{ wordWrap: 'break-word' }}
            >
              <Typography variant="label1">
                {field.accessor === 'packagedItemDescription'
                  ? `${t('fields.product')} ${productIndex}`
                  : renderLabel(field)}
                :
              </Typography>
              <Typography variant="body2">{renderValue(field)}</Typography>
            </Grid>
          ))}
        </Grid>
      ))}
    </>
  );
}
